<template>
  <a-select-option :class="bem.b()" v-bind="props">
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-select-option>
</template>

<script setup lang="ts">
import { selectOptionProps } from './select'
// import { SelectOption } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'

defineOptions({ name: 'LlSelectOption' })

const props = defineProps(selectOptionProps)

const bem = createNamespace('select-option')
</script>
